import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormSyncErrors } from 'redux-form';

import EditGuestGroupFormContainer from './EditGuestGroupFormContainer';

const EditGuestGroupModal = ({ guestGroupId, activeTab, callback }) => (
  <div id="edit-guest-group-modal">
    <div className="modal-header">
      <div className="row">
        <div className="col-xs-6 col-sm-6 col-md-6">
          <h3 className="modal-title margin-bottom">Edit Guest</h3>
        </div>
      </div>
    </div>
    <div className="modal-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12 col-md-12">
            <EditGuestGroupFormContainer
              guestGroupId={guestGroupId}
              activeTab={activeTab}
              callback={callback}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

EditGuestGroupModal.propTypes = {
  guestGroupId: PropTypes.number.isRequired,
  activeTab: PropTypes.oneOf(['GUESTS', 'CONTACT', 'ENVELOPE', 'RSVP']),
  callback: PropTypes.func,
  formErrors: PropTypes.shape({}),
};
const mapStateToProps = state => ({
  formErrors: getFormSyncErrors('editGuestGroupForm')(state),
});

export default connect(mapStateToProps)(EditGuestGroupModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/EditGuestGroupWeddingsModal.jsx